

















import { computed, defineComponent, onMounted } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import facebook from "@/lib/facebook";
import google from "@/lib/google";
import { $t } from "@/lib/i18nHelpers";
import { loginFacebook, loginGoogle, loginTwitter } from "@/lib/loginHelpers";
import twitter from "@/lib/twitter";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import SocialLoginButton from "./SocialLoginButton";

export default defineComponent({
  name: "SocialLogin",
  components: { SocialLoginButton, BaseButton, BaseIcon },
  props: { title: { type: String, default: $t("or log in with") } },
  setup(_, { emit }) {
    const { setSocialLoginStatus } = useAuthUser();
    const allowedAuth = computed(() => config.auth);
    const hasOauth = computed(() => Object.values(allowedAuth.value).some(v => v));

    const twLogin = async () => {
      try {
        const response = await twitter.login();
        if (!response) {
          return;
        }
        setSocialLoginStatus(true);
        await loginTwitter({
          ...response,
          role: config.userRegistrationRole,
        });
        emit("social");
      } catch {
        setSocialLoginStatus(false);
      }
    };
    const fbLogin = async () => {
      try {
        const token = await facebook.login();
        setSocialLoginStatus(true);
        await loginFacebook({ role: config.userRegistrationRole, token: token.authResponse.accessToken });
        emit("social");
      } catch {
        setSocialLoginStatus(false);
      }
    };
    const gglLogin = async (promise: Promise<{ code: string }>) => {
      try {
        const token = await promise;
        setSocialLoginStatus(true);
        await loginGoogle({ role: config.userRegistrationRole, token: token.code });
        emit("social");
      } catch {
        setSocialLoginStatus(false);
      }
    };
    onMounted(async () => {
      if (allowedAuth.value.google) {
        await gglLogin(google.login("google_btn"));
      }
    });

    return { allowedAuth, hasOauth, twLogin, fbLogin };
  },
});
